import { HttpClient, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Membro } from '../_models/membro';
import { Notificacao } from '../_models/notificacao';
import { QuizzRespostas } from '../_models/quizz';
import { Sac } from '../_models/sac';
import { SmsRequestModel } from '../_models/smsRequestModel';
import { Solicitacoes, SolicitacoesStatus } from '../_models/solicitacoes';
import { BaseService } from './base.service';

import filtroExperiencia from '../_models/filtroExperiencia';
import filtroExtrato from '../_models/filtroExtrato';
@Injectable()
export class FidelidadeService extends BaseService {
  private fidelidade: string = environment.urlBase;
  private nivelMozao: string = '9';

  // Abre termos no app
  private eventTriggerTermo = new Subject<void>();
  eventTriggerTermo$ = this.eventTriggerTermo.asObservable();

  // Abre regulamentos no app
  private eventTriggerRegulamento = new Subject<void>();
  eventTriggerRegulamento$ = this.eventTriggerRegulamento.asObservable();


  constructor(private http: HttpClient) {
    super();
  }

  redirecionarEcommerce(): Observable<void> {
    const urlEcommrece = 'https://www.cacaushow.com.br/';
    const usuario = this.LocalStorage.usuarioValido();

    if (!this.LocalStorage.usuarioValido()) {
      window.open(urlEcommrece, '_blank');
      return;
    }

    if (this.LocalStorage.tokenEstaExpirado(usuario)) {
      window.open(urlEcommrece, '_blank');
      return;
    }

    this.ObterUrlAutenticacaoSalesForce().subscribe(
      (sucesso: any) => {
        window.open(sucesso.urlSso, '_blank');
      },
      (error: any) => {
        window.open(urlEcommrece, '_blank');
      }
    );
  }

  // Transação/Extrato
  obterExtrato(dias: number): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + 'transacao/extrato/' + dias + '?exibirResgates=false',
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterTransacaoAExpirar(): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + 'transacao/obtertransacaoaexpirar',
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterItensTransacao(idTransacao: number): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + 'transacao/compra/' + idTransacao,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterExtratoExpirados(dias: number): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + 'transacao/expirados/' + dias,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterExtratoPorFiltro(filtro: filtroExtrato): Observable<any> {
    let response = this.http
      .post(
        this.UrlService + `Transacao/obterExtratoPorFiltro`,
        filtro,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));
    return response;
  }

  //Descontos
  obterDescontosParaLovers(idTipoDesconto: number): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `DescontosParaLovers/obtertodos/${idTipoDesconto}`,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterConteudoDosCarrosseis(): Observable<any> {
    let response = this.http
      .get(this.UrlService + 'TiposDescontos', this.obterHeaderJsonToken())
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterConteudoDosCarrosseisPorNivel(): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + 'TiposDescontos/ObterPorNivel',
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterDescontoParaLovers(idTipoDescontos: number): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `DescontosParaLovers/obtertodos/` + idTipoDescontos,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  //Transacao
  obterPedidos(dias: number): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `Transacao/ObterPedidos/${dias}`,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterHistoricoTransacaoPorMembro(): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + 'transacao/ObterHistoricoTransacaoPorMembro',
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterResumoPontosAVencer(): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + 'transacao/ObterResumoPontosAVencer',
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  // MEMBROS
  verificarSeJaEstaCadastrado(documento): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `Cadastro/ObterCpfValido/${documento}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterMembro(): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `Cadastro?exibePromocoes=false`,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterMembroPorToken(token: string): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `Cadastro?exibePromocoes=false`,
        this.obterHeaderJsonWithToken(token)
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }
  obterDadosResponsavel(cpf: string): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `Cadastro/obter-dados-responsavel/${cpf}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterTotalMembrosAtivos(): Observable<any> {
    let response = this.http
      .get(this.UrlService + `Cadastro/ObterTotalAtivo`, this.obterHeaderJson())
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterEnderecosMembro(): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `Cadastro/ObterEnderecos`,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  getFoto(): Observable<any> {
    let response = this.http
      .get(this.UrlService + `Cadastro/getFoto`, this.obterHeaderJsonToken())
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  cadastrarMembro(membro: Membro): Observable<any> {
    let response = this.http
      .post(this.UrlService + `Cadastro`, membro, this.obterHeaderJson())
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  enviarEmailEsqueciSenhaMembro(cpf: string): Observable<any> {
    let response = this.http
      .post(
        this.UrlService + 'Cadastro/EnviarEmail/' + cpf,
        '',
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  enviarEmailSac(sacEmail: any): Observable<any> {
    let response = this.http
      .post(
        this.UrlService + 'Cadastro/EnviarEmailSac',
        sacEmail,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  uploadFoto(formData: FormData): HttpRequest<any> {
    return new HttpRequest(
      'POST',
      this.UrlService + `Cadastro/uploadFoto`,
      formData,
      this.obterHeaderJsonTokenComReportProgress()
    );
  }

  atualizarMembro(membro: Membro, responsavel: string): Observable<any> {
    let response = this.http
      .put(
        this.UrlService + `Cadastro/${responsavel}/SiteCacauLovers`,
        membro,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  atualizarMembroSemToken(membro: Membro, responsavel: string, token: string): Observable<any> {
    let response = this.http
      .put(
        this.UrlService + `Cadastro/${responsavel}/SiteCacauLovers`,
        membro,
        this.obterHeaderJsonTokenParans(token)
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  atualizarMembroPorTelaCadastro(
    membro: Membro,
    responsavel: string,
    token: string
  ): Observable<any> {
    let response = this.http
      .put(
        this.UrlService + `Cadastro/${responsavel}/SiteCacauLovers`,
        membro,
        this.obterHeaderJsonComToken(token)
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  atualizarMembroPorTelaCadastroStatusRecadastro(
    membro: Membro,
    responsavel: string,
  ): Observable<any> {
    let response = this.http
      .put(
        this.UrlService + `Cadastro/Invalido/${responsavel}/Site`,
        membro,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  atualizarMembroValidaDados(
    membro: Membro,
    responsavel: string
  ): Observable<any> {
    membro.atributos = null;
    let response = this.http
      .put(
        this.UrlService + `Cadastro/${responsavel}/SiteCacauLoversValidaDados`,
        membro,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));
    return response;
  }

  atualizarMembroSenha(token: string, membro: Membro): Observable<any> {
    let response = this.http
      .put(
        this.UrlService + 'Cadastro/atualizarsenha?token=' + token,
        membro,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  atualizarAceiteDeComunicacao(
    token: string,
    comunicacao: boolean
  ): Observable<any> {
    let response = this.http
      .put(
        this.UrlService +
        'Cadastro/atualizar-comunicacao/comunicacao:' +
        comunicacao,
        {},
        this.obterHeaderJsonComToken(token)
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  abrirChamadoCRM(sac: Sac): Observable<any> {
    let response = this.http
      .post(
        this.UrlService + `Cadastro/abrirChamadoCRM`,
        sac,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  inativarPorCpf(ip: string, usuario: string, cpf: string): Observable<any> {
    let response = this.http
      .post(
        this.UrlService + `Cadastro/inativarPorCpf`,
        {
          ip: ip,
          usuarioInativacao: usuario,
          cpf: cpf,
          canal: 'Site CacauLovers',
          idChamado: '0',
        },
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  registrarLogAceiteRegulamento(
    ip: string,
    regulamento: string,
    cpf: string
  ): Observable<any> {
    let response = this.http
      .post(
        this.UrlService + `Cadastro/registrarLogAceiteRegulamento`,
        { ip: ip, regulamento: regulamento, cpf: cpf },
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterIndicacoes(id: number): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `Cadastro/obterIndicacoesPorIdMembroIndicacao/${id}`,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }


  obterPorTelefone(telefone: string): Observable<any> {
    let response = this.http
      .get(
        `${this.UrlService}Cadastro/obterPorTelefone/${telefone}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  // Experiências
  obterExperiencias(idNivel: number, cpf: string): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `experiencia/listar/${cpf}?idNivel=${idNivel}`,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterExperienciasPorPaginaETipos(
    pagina: string,
    tipos: string
  ): Observable<any> {
    let url = 'experiencia/obterexperienciasporpaginaetipos';
    if (pagina != '' && tipos != null)
      url += `?pagina=${pagina}&tipos=${tipos}`;
    else if (pagina != '') url += `?pagina=${pagina}`;
    else url += `?tipos=${tipos}`;

    let response = this.http
      .get(this.UrlService + url, this.obterHeaderJsonToken())
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterExperienciaPorId(
    idExperiencia: number,
    idGrupo: number
  ): Observable<any> {
    let response = this.http
      .get(
        this.UrlService +
        `experiencia/obter-detalhe/${idExperiencia}/${idGrupo}`,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterExperienciaPorNomeIdentificador(
    idMembro: number,
    nomeIdentificador: string
  ): Observable<any> {
    let response = this.http
      .get(
        `${this.UrlService}experiencia/obter-detalhe-por-identificador/${idMembro}/${nomeIdentificador}`,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterExperiencia(idExperiencia: number): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `experiencia/obter-detalhe-por-id/${idExperiencia}`,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  resgatarExperiencia(
    idExperienciaParceiro: number,
    cpf: string,
    quantidade: number,
    idExperienciaLote: number,
    idParceiroEndereco: number,
    acompanhantes: string
  ): Observable<any> {
    let membroExperiencia: any = {
      documento: cpf,
      idExperienciaParceiro: idExperienciaParceiro,
      quantidade: quantidade,
      acompanhantes: acompanhantes,
    };

    if (idExperienciaLote !== 0) {
      membroExperiencia = {
        ...membroExperiencia,
        idExperienciaLote: idExperienciaLote,
      };
    }

    if (idParceiroEndereco !== 0) {
      membroExperiencia = {
        ...membroExperiencia,
        idParceiroEndereco: idParceiroEndereco,
      };
    }

    let response = this.http
      .post(
        this.UrlService + `experiencia/membro-confirmacao-inserir`,
        membroExperiencia,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterExtratoExperiencias(cpf: string, dias: number): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `experiencia/listar-experiencia-membro/${cpf}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterExperienciasPorPagina(pagina: string): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `experiencia/obterExperienciaPorPagina/${pagina}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterListaEstadoPorExperiencia(idExperiencia: number): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `Parceiro/listar-endereco-estado/${idExperiencia}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterListaDeEnderecoPorEstadoEExperiencia(
    idExperiencia: number,
    estado: string
  ): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `Parceiro/listar-endereco/${idExperiencia}/${estado}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterListaEnderecosProximos(
    idExperiencia: number,
    latitude: number,
    longitude: number
  ): Observable<any> {
    var objEndereco: any = {
      IdExperiencia: idExperiencia,
      Latitude: latitude,
      Longitude: longitude,
    };

    let response = this.http
      .post(
        this.UrlService + `Parceiro/listar-enderecos-proximos`,
        objEndereco,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterValidacoesDeCondicaoDeResgate(
    idExperiencia: number,
    cpf: string
  ): Observable<any> {
    const url = `${this.UrlService}experiencia/validar-condicoes-resgate/${idExperiencia}/${cpf}`;
    return this.http.get(url, this.obterHeaderJson());
  }

  //Benefícios Níveis
  obterBeneficiosDosNiveis(): Observable<any> {
    let response = this.http
      .get(this.UrlService + `Beneficio`, this.obterHeaderJson())
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterNiveis(): Observable<any> {
    let response = this.http
      .get(this.UrlService + `Nivel`, this.obterHeaderJson())
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  //Configuracões
  obterConfiguracaoPorDescricao(descricao: string): Observable<any> {
    if (descricao == 'regulamento')
      if (
        this.LocalStorage.currentUserNivel != null &&
        this.LocalStorage.currentUserNivel != undefined
      )
        if (this.LocalStorage.obterNivel() == this.nivelMozao)
          descricao = 'regulamento_mozão';

    let response = this.http
      .get(
        this.UrlService +
        `Configuracoes/ObterConfiguracaoPorDescricao/` +
        descricao,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterFAQPorTipoExibicao(idTipo: number, idGrupo: number): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `Experiencia/listar-grupo-fac/${idTipo}/${idGrupo}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterFAQPorNome(nome: string): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `Experiencia/obter-grupo-faq/${nome}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterFAQPorRota(rota: string): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `Experiencia/obter-grupo-faq-por-rota/${rota}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  //Quizz
  obterQuizzPorTipoVisualizacao(
    exibirUsuarioLogado: boolean,
    exibirUsuarioNaoLogado: boolean,
    exibirTodos: boolean,
    somenteAtivos: boolean
  ): Observable<any> {
    let response = this.http
      .get(
        this.UrlService +
        `Quizz/ObterQuizzPorTipoVisualizacao/${exibirUsuarioLogado}/${exibirUsuarioNaoLogado}/${exibirTodos}/${somenteAtivos}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterQuizzPorId(idQuizz: number): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `Quizz/obterQuizzPorId/${idQuizz}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterQuizzPerguntasPorIdQuizz(idQuizz: number): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `Quizz/ObterQuizzPerguntasPorIdQuizz/${idQuizz}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  cadastrarQuizzRespostas(quizzRespostas: QuizzRespostas[]): Observable<any> {
    let response = this.http
      .post(
        this.UrlService + `Quizz/CadastrarQuizzRespostas`,
        quizzRespostas,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  cadastrarQuizzRespostasPorUsuario(
    quizzRespostas: QuizzRespostas[]
  ): Observable<any> {
    let response = this.http
      .post(
        this.UrlService + `Quizz/CadastrarQuizzRespostas`,
        quizzRespostas,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  //NPS
  verificarSeHouveCompras(): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `Transacao/obterPedidosPendenteAvaliacaoPorDocumento`,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  enviarNota(nps): Observable<any> {
    let response = this.http
      .post(
        this.UrlService + `Transacao/cadastrarNPS`,
        nps,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  // Token
  obterToken(): Observable<any> {
    let response = this.http
      .get(this.UrlService + `Cadastro/ObterToken`, this.obterHeaderJsonToken())
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterTokenPorCPF(cpf: string): Observable<any> {
    let response = this.http
      .get(
        `${this.UrlService}Autenticacao?documento=${cpf}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterTokenPorCPFBody(cpf: string): Observable<any> {
    let response = this.http
      .post(
        `${this.UrlService}Autenticacao`,
        {
          'cpf': cpf,
          'senha': "",
          'verificaStatus': true,
        },

        this.obterHeaderJsonXAPI()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  ObterUrlAutenticacaoSalesForce(): Observable<any> {
    let response = this.http
      .get(
        `${this.UrlService}ObterUrlAutenticacaoSsoSalesForce`,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterTextoEncryptado(texto: string): Observable<any> {
    let response = this.http
      .get(`${this.UrlService}encryptString/${texto}`, this.obterHeaderJson())
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  //Notificações
  ObterGrupoNotificacaoPorIdMembroOuNivel(
    somenteAtivos: boolean,
    idMembro?: number,
    idNivel?: number
  ): Observable<any> {
    if (idMembro != undefined && idNivel != undefined) {
      let response = this.http
        .get(
          this.UrlService +
          `Notificacao/ObterGrupoNotificacaoPorIdMembroOuNivel?idMembro=${idMembro}&idNivel=${idNivel}&somenteAtivos=${somenteAtivos}`,
          this.obterHeaderJson()
        )
        .pipe(map(this.extractData), catchError(this.serviceError));

      return response;
    } else if (idMembro != undefined) {
      let response = this.http
        .get(
          this.UrlService +
          `Notificacao/ObterGrupoNotificacaoPorIdMembroOuNivel?idMembro=${idMembro}&somenteAtivos=${somenteAtivos}`,
          this.obterHeaderJson()
        )
        .pipe(map(this.extractData), catchError(this.serviceError));

      return response;
    } else if (idNivel != undefined) {
      let response = this.http
        .get(
          this.UrlService +
          `Notificacao/ObterGrupoNotificacaoPorIdMembroOuNivel?idNivel=${idNivel}&somenteAtivos=${somenteAtivos}`,
          this.obterHeaderJson()
        )
        .pipe(map(this.extractData), catchError(this.serviceError));

      return response;
    }
  }

  obterNotificacaoNaoLidaPorIdMembroEIdNivel(
    idMembro: number,
    idNivel: number
  ): Observable<any> {
    let response = this.http
      .get(
        this.UrlService +
        `Notificacao/obterGrupoNotificacaoNaoLidoPorIdMembroENivel?idMembro=${idMembro}&idNivel=${idNivel}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  marcarNotificacaoComoLida(
    notificacao: Notificacao,
    idMembro: number
  ): Observable<any> {
    let response = this.http
      .put(
        this.UrlService + `Notificacao/marcarNotificacaoComoLida/${idMembro}`,
        notificacao,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  // Desafios
  obterDesafios(cpf: string): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `Desafios/ObterAtivos/${cpf}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterDesafioPorId(idDesafio: number) {
    let response = this.http
      .get(
        this.UrlService + `Desafios/Obter/${idDesafio}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  aceitarDesafio(idDesafio: number, idMembro: number): Observable<any> {
    let response = this.http
      .post(
        this.UrlService + `Desafios/aceitar-desafio/${idDesafio}/${idMembro}`,
        null,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  //Email e SMS

  enviarSmsValidarCampoComToken(token: string) {
    const emailsms = JSON.parse(window.atob(localStorage.getItem('emailsms')));

    let response = this.http
      .post(
        this.UrlServiceEmailSms + `api/sms/enviarSmsValidarCampoComToken`,
        emailsms,
        this.obterHeaderJson(),
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  enviarEmailValidarEmailComToken(token: string) {
    const emailsms = JSON.parse(window.atob(localStorage.getItem('emailsms')));
    let response = this.http
      .post(
        this.UrlServiceEmailSms + `api/email/enviarEmailValidarEmailComToken`,
        emailsms,
        this.obterHeaderJson(),
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  validarPinCodeEmailValidarCampoComToken(pinCode: string) {
    const emailsms = JSON.parse(window.atob(localStorage.getItem('emailsms')));
    const pincodeMembro = {
      ...emailsms,
      pincode: +pinCode
    }
    let response = this.http
      .post(
        this.UrlServiceEmailSms +
        `api/email/validarPinCodeEmailValidarCampoComToken`,
        pincodeMembro,
        this.obterHeaderJson(),
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  validarPinCodeSmsValidarCampoComToken(pinCode: string) {
    const emailsms = JSON.parse(window.atob(localStorage.getItem('emailsms')));
    const pincodeMembro = {
      ...emailsms,
      pincode: +pinCode
    }
    let response = this.http
      .post(
        this.UrlServiceEmailSms +
        `api/sms/validarPinCodeSmsValidarCampoComToken`,
        pincodeMembro,
        this.obterHeaderJson(),
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  enviarSmsValidarCampo(message: SmsRequestModel) {
    let response = this.http
      .post(
        this.UrlServiceEmailSms + `api/sms/enviarSmsValidarCampo`,
        message,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  enviarSmsValidarCampoComIdMembro(message: SmsRequestModel, idMembro: number) {
    let response = this.http
      .post(
        this.UrlServiceEmailSms +
        `api/sms/enviarSmsValidarCampoComIdMembro/${idMembro}`,
        message,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  validarPinCodeSmsValidarCampo(message: SmsRequestModel, pinCode: string) {
    let response = this.http
      .post(
        this.UrlServiceEmailSms +
        `api/sms/validarPinCodeSmsValidarCampo/${pinCode}`,
        message,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  enviarEmailValidarCampo(membro: Membro) {
    let response = this.http
      .post(
        this.UrlServiceEmailSms + `api/email/enviarEmailValidarEmail`,
        {
          EmailDestinatario: membro.email,
          Substitutions: { '{codigo_validacao}': '' },
        },
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  enviarEmailValidarCampoComIdMembro(
    emailDestinatario: string,
    idMembro: number
  ) {
    let response = this.http
      .post(
        this.UrlServiceEmailSms +
        `api/email/enviarEmailValidarEmailComIdMembro/${idMembro}`,
        {
          EmailDestinatario: emailDestinatario,
          Substitutions: { '{codigo_validacao}': '' },
        },
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  validarPinCodeEmailValidarCampo(membro: Membro, pinCode: string) {
    let response = this.http
      .post(
        this.UrlServiceEmailSms +
        `api/email/validarPinCodeEmailValidarCampo/${pinCode}`,
        {
          EmailDestinatario: membro.email,
          Substitutions: { '{codigo_validacao}': '' },
        },
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  enviarEmailYupChat(request: any) {
    let response = this.http
      .post(
        this.UrlServiceEmailSms + 'api/email/enviarEmailYupChat/',
        request,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  enviarEmailIndicacao(request: any) {
    let response = this.http
      .post(
        this.UrlServiceEmailSms + 'api/email/enviarEmailIndicacao',
        request,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterCep(cep: string) {
    var url = `${this.CepGateway}/${cep}/json/`;
    return this.http.get(url, this.obterHeaderJsonSimples());
  }

  buscarParceiroPorId(id: number) {
    let response = this.http
      .get(`${this.UrlService}parceiro/obter/${id}`, this.obterHeaderJson())
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  listarEstados() {
    let response = this.http
      .get(`${this.UrlService}parceiro/listar-estados`, this.obterHeaderJson())
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterTiposExperiencias(
    nome: string,
    nmTipo: string,
    tiposExperiencia: string
  ) {
    let response = this.http
      .get(
        `${this.UrlService}tipo/obter-filtros-de-experiencia-por-tabela-tipo-e-tiposExperiencia/${nome}/${nmTipo}?tiposExperiencia=${tiposExperiencia}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  searchExperiencias(filtros: filtroExperiencia) {
    var url = `${this.UrlService}experiencia/search?`;
    if (filtros.tipos != '') url += `tipos=${filtros.tipos}&`;
    if (filtros.niveis != '') url += `niveis=${filtros.niveis}&`;
    if (filtros.rangeCacaus != null)
      url += `rangeCacaus=${filtros.rangeCacaus}&`;
    if (filtros.campanhas != '') url += `campanhas=${filtros.campanhas}&`;
    if (filtros.categorias != '') url += `categorias=${filtros.categorias}&`;
    if (filtros.ordem > 0) url += `ordem=${filtros.ordem}&`;
    if (filtros.estados != '') url += `estados=${filtros.estados}&`;
    if (filtros.descricao != '') url += `descricao=${filtros.descricao}&`;
    if (filtros.filtraQuantidadeDisponivel != null)
      url += `filtraQuantidadeDisponivel=${filtros.filtraQuantidadeDisponivel}&`;
    if (filtros.pagina != undefined && filtros.pagina != null)
      url += `pagina=${filtros.pagina}&`;
    if (
      filtros.ehTelaMomentoEspecial != undefined &&
      filtros.ehTelaMomentoEspecial != null
    )
      url += `ehTelaMomentoEspecial=${filtros.ehTelaMomentoEspecial}&`;
    if (filtros.somenteAtivos != undefined)
      url += `somenteAtivos=${filtros.somenteAtivos}`;

    let response = this.http
      .get(url, this.obterHeaderJson())
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  listaEnderecosLote(
    idExperiencia: number,
    latitude: number,
    longitude: number
  ) {
    let response = this.http
      .get(
        `${this.UrlService}experiencia/listar-enderecos-lote-proximos/${idExperiencia}/${longitude}/${latitude}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  //Solicitações
  ObterSolicitacoesPorIdMembroAprovador(
    idMembroAprovador: number,
    idTipoAprovacao: number[],
    lstEnumStatusSolicitacoes: SolicitacoesStatus[]
  ) {
    const objRequest = {
      idMembroAprovador: idMembroAprovador,
      LstIdTipoAprovacao: [],
      lstEnumStatusSolicitacoes: [],
      page: 1,
      size: 10000,
    };

    lstEnumStatusSolicitacoes.forEach((element) => {
      objRequest.lstEnumStatusSolicitacoes.push(element.toString());
    });

    idTipoAprovacao.forEach((element) => {
      objRequest.LstIdTipoAprovacao.push(element.toString());
    });

    let response = this.http
      .post(
        `${this.UrlService}solicitacoes/obterPorIdMembroAprovador`,
        objRequest,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  atualizarSolicitacao(solicitacao: Solicitacoes) {
    let response = this.http
      .put(
        `${this.UrlService}solicitacoes/atualizarSolicitacao`,
        solicitacao,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  inserirParceiro(formData: any) {
    var url = `${this.UrlService}parceiro/inserir`;
    return this.http.post(url, formData, this.httpOptionsFormData());
  }

  // Sorteio
  participarSorteio(sorteio: any) {
    let response = this.http
      .post(
        `${this.UrlService}sorteioParticipantes/criarSorteioParticipantes`,
        sorteio,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterSorteiosPorMembro(sorteio: any) {
    let response = this.http
      .post(
        `${this.UrlService}sorteioParticipantes/obterSorteioParticipantes`,
        sorteio,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterComprasSorteio(sorteio: any) {
    let response = this.http
      .post(
        `${this.UrlService}sorteioParticipantes/obterSorteioParticipantesCompras`,
        sorteio,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  cadastrarPincodeSorteio(
    idSorteio: number,
    idMembro: number,
    pincode: string
  ) {
    let response = this.http
      .get(
        `${this.UrlService}sorteioParticipantes/cadastrarPinCode/${idSorteio}/${idMembro}/${pincode}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterResultadoSorteio(idSorteio: number, idMembro: number = 0) {
    let response = this.http
      .post(
        `${this.UrlService}sorteioResultado/obterResultadoSorteioPorIdSorteioIdMembro/${idSorteio}/${idMembro}`,
        null,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  // Promoções
  obterPromocaoPorId(id: any) {
    let response = this.http
      .get(
        `${this.UrlService}promocoes/obter-por-id/${id}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  validarEmailOuTelefoneDisponivel(membro: Membro, campoValidacao: string) {
    let response = this.http
      .post(
        this.UrlService +
        `Cadastro/validarEmailOuTelefoneDisponivel/${campoValidacao}`,
        membro,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  aceitarTodosDesafios(idMembro: number) {
    let response = this.http
      .get(
        this.UrlService + `desafios/aceitarTodosDesafios/${idMembro}`,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  abrirTermoApp() {
    this.eventTriggerTermo.next();
  }

  abrirRegulamento() {
    this.eventTriggerRegulamento.next();
  }

  // Voucher palito premiado

  consumirVoucher(membroVoucher: any) {
    let response = this.http
      .post(
        this.fidelidade + `voucherMembro/criarVoucherMembro`,
        membroVoucher,
        this.obterHeaderJsonToken()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  consultarVoucher(voucher: any) {
    let response = this.http
      .post(
        this.fidelidade + `Voucher/obterPorCodigo`,
        voucher,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  obterTipos(
    nome: string,
    nmTipo: string
  ) {
    let response = this.http
      .get(
        `${this.UrlService}tipo/obter-por-tabela-e-tipo/${nome}/${nmTipo}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  verificarTelefoneDisponivel(telefone: string, documento: string): Observable<any> {
    let url = `${this.UrlService}Cadastro/verificar-telefone-disponivel/${telefone}`;

    if (documento) {
      url += `?documento=${documento}`;
    }

    let response = this.http
      .get(
        url,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  verificarResponsavelValido(cpf: string): Observable<any> {
    let response = this.http
      .get(
        this.UrlService + `Cadastro/verificar-responsavel-valido/${cpf}`,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  verificarEmailDisponivel(email: string, documento: string): Observable<any> {
    let url = this.UrlService + `Cadastro/verificar-email-disponivel/${email}`;

    if (documento) {
      url += `?documento=${documento}`;
    }

    let response = this.http
      .get(
        url,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }
}
